<div class="container main-box">

    <div class="row main-box-header">
        <div class="col-xs-12">
            <div class="form-group" *ngIf="!singleUploadResume">
                <label style="padding-right: 10px" *ngIf="showResumeOptions && !loadingResumeOptions">
                    Add New Candidates:
                </label>
                <div class="radio" style="display: inline;" *ngIf="showResumeOptions && !loadingResumeOptions">
                    <input type="radio" name="addCandidateType" id="addCandidatesWithResume" [value]="true"
                        [(ngModel)]="addWithResumesFlag" (ngModelChange)="onAddCandidateOptionChange()">
                    <label for="addCandidatesWithResume">
                        With Resumes
                    </label>
                </div>
                <div class="radio" style="display: inline;" *ngIf="showResumeOptions && !loadingResumeOptions">
                    <input type="radio" name="addCandidateType" id="addCandidatesWithoutResume" [value]="false"
                        [(ngModel)]="addWithResumesFlag" (ngModelChange)="onAddCandidateOptionChange()">
                    <label for="addCandidatesWithoutResume">
                        Without Resumes
                    </label>
                </div>
                <div class="pull-right" *ngIf="addWithResumesFlag && context != 'candidateJobMatchWorkflow'">
                    <button type="button" class="btn btn-danger btn-cancel" (click)="cancel()" [disabled]="controlObject.disableCancelButtonFlag">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row main-box-body">
        <div class="col-xs-12" [hidden]="loadingResumeOptions" *ngIf="!addWithResumesFlag">
            <tabset>
                <tab heading="Add Candidates">
                    <div class="row" *ngFor="let candidate of candidatesArray; let i = index">
                        <div class="col-xs-12 main-box">
                            <div class="row main-box-header">
                                <div class="col-xs-12">
                                    <div class="pull-left">
                                        <b>New Candidate {{ i + 1 }}</b>
                                        <i class="fa" [ngClass]="{'fa-check dark-green': candidate.addStatus == 'success', 'fa-times red': candidate.addStatus == 'error'}"></i>
                                    </div>
                                    <div class="pull-right" *ngIf="candidate.addStatus != 'success' && i != 0">
                                        <span>
                                            <i class="fa fa-times pointer" tooltip="Remove Candidate" (click)="removeCandidate(i)"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-12" *ngIf="candidate.addStatus == 'error'">
                                    <div class="alert alert-danger add-candidate-alert">
                                        <div *ngFor="let message of candidate.errorMessages">
                                            <strong>Error!</strong> {{message}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12" *ngIf="candidate.addStatus == 'success'">
                                    <div class="alert alert-success add-candidate-alert">
                                        <strong>Success!</strong> Candidate added successfully.
                                    </div>
                                </div>
                            </div>
                            <div class="row main-box-body add-candidate-form-container">
                                <form role="form" #addForm="ngForm" novalidate>
                                    <div class="row">
                                        <div class="col-xs-12 col-md-6">
                                            <div class="form-group" [ngClass]="{'has-error': (candidate.submitted && firstName.invalid)}">
                                                <label for="firstName" class="control-label">
                                                    First Name<em>*</em> :
                                                </label>
                                                <input type="text" name="firstName" id="firstName" class="form-control" placeholder="First Name"
                                                       [(ngModel)]="candidate.firstName" #firstName="ngModel" required [disabled]="candidate.addStatus == 'success'">
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-6">
                                            <div class="form-group" [ngClass]="{'has-error': (candidate.submitted && lastName.invalid)}">
                                                <label for="lastName" class="control-label">
                                                    Last Name<em>*</em> :
                                                </label>
                                                <input type="text" name="lastName" id="lastName" class="form-control" placeholder="Last Name"
                                                       [(ngModel)]="candidate.lastName" #lastName="ngModel" required [disabled]="candidate.addStatus == 'success'">
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-6">
                                            <div class="form-group" [ngClass]="{'has-error': (candidate.submitted && email.invalid)}">
                                                <label for="email" class="control-label">
                                                    Email<em>*</em> :
                                                </label>
                                                <input type="email" name="email" id="email" class="form-control" placeholder="Email"
                                                       [(ngModel)]="candidate.emailId" #email="ngModel" required [disabled]="candidate.addStatus == 'success'">
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-md-6">
                                            <div class="form-group">
                                                <label for="phoneNumber{{i + 1}}" class="control-label">
                                                    Phone Number :
                                                </label>
                                                <angular-four-dot-five-phone-number [elementId]="'phoneNumber' + (i + 1)" [valueField]="candidate.phoneNumber"
                                                    (valueFieldChange)="candidate.phoneNumber = $event" [isRequired]="false" [readOnly]="candidate.addStatus == 'success'"
                                                    (isPhoneNumberInvalid)="candidate.phoneNumberInvalid = $event"></angular-four-dot-five-phone-number>
                                            </div>
                                            <div class="error form-group" *ngIf="candidate.submitted && candidate.phoneNumberInvalid">
                                                <small class="error">Please enter a valid phone number.</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="i == (candidatesArray.length - 1)">
                                        <div class="col-xs-12">
                                            <button type="button" class="btn btn-success" (click)="addAnotherCandidate()">
                                                Add Another Candidate
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3" *ngIf="isOutreachEnabled">
                        <app-send-candidate-outreach-email [outreachEmailId]="'addCandidates'" [sendOutreachEmail]="sendOutreachEmail" (sendOutreachEmailUpdated)="sendOutreachEmail = $event"></app-send-candidate-outreach-email>
                    </div>
                    <div class="row main-box-footer px-3" *ngIf="!addWithResumesFlag">
                        <div class="row text-right">
                            <div class="clearfix">
                                <button type="button" class="btn btn-danger mr-2" (click)="cancel()" [disabled]="savingFlag">
                                    <span>Cancel</span>
                                </button>
                                <button type="submit" class="btn btn-success" (click)="saveCandidates()" [disabled]="savingFlag">
                                    <span *ngIf="!savingFlag">Save</span>
                                    <span *ngIf="savingFlag">Saving..</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </tab>
                <tab heading="Upload Candidate File">
                    <app-candidate-file-upload [jobId]="jobId"
                        [clientOrBuId]="clientOrBuId"
                        (cancelCallback)="saveCallback.emit()"
                        (completeCallback)="saveCallback.emit()">
                    </app-candidate-file-upload>
                </tab>
            </tabset>

        </div>
        <div class="col-xs-12" [hidden]="loadingResumeOptions" *ngIf="addWithResumesFlag && !singleUploadResume">
            <app-unified-resume-upload
                [jobId]="jobId"
                [candidateId]="candidateId"
                [disableSourceTypesFlag]="disableSourceTypesFlag"
                (cancelCallback)="saveCallback.emit()"
                (candidateProcessedCallback)="onCandidateProcessed()"
                (completeCallback)="saveCallback.emit()"
                (filesUploadedCallback)="onFilesUploaded()"
                [controlObject]="controlObject"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-unified-resume-upload>
        </div>
        <div class="col-xs-12" *ngIf="singleUploadResume">
            <app-upload-single-resume
                [jobId]="jobId"
                [candidateId]="candidateId"
                (cancelCallback)="saveCallback.emit()"
                (candidateProcessedCallback)="onCandidateProcessed()"
                (completeCallback)="saveCallback.emit()"
                [controlObject]="controlObject"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-upload-single-resume>
        </div>
        <div class="col-xs-12 skeleton-container" *ngIf="loadingResumeOptions">
            <div class="skeleton-heading skeleton-loading" style="width:35%; margin-bottom:14px"></div>
            <div class="skeleton-paragraph skeleton-loading" style="width:20%; margin-bottom:8px"></div>
            <div class="skeleton-loading" style="height:34px; width:100%; margin-bottom:14px"></div>
            <div class="skeleton-paragraph skeleton-loading" style="width:20%; margin-bottom:8px"></div>
            <div class="skeleton-loading" style="height:34px; width:100%"></div>
        </div>
    </div>
</div>
